import { FileDown } from 'lucide-react'
import { ComponentProps } from 'react'
import { webchatClasses } from '../../../styles/classes'
import { FileBlock, type CommonBlockProps } from '../../../types'

type Props = FileBlock & CommonBlockProps & ComponentProps<'a'>

export const File = ({ ref, title, url, isReadOnly, ...props }: Props) => {
  const {
    message: {
      blocks: { file },
    },
  } = webchatClasses

  return (
    <a
      {...props}
      {...file.container}
      href={url}
      style={isReadOnly ? { pointerEvents: 'none' } : undefined}
      download
      ref={ref}
      target="_blank"
      rel="noreferrer"
    >
      <p {...file.title}>{title || url}</p>
      <FileDown {...file.icon} />
    </a>
  )
}

File.displayName = 'File'
